import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dd6a446"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-5 full-width"
}
const _hoisted_2 = { class: "collection-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "is-flex is-justify-content-space-between mt-3"
}
const _hoisted_5 = { class: "has-text-grey has-text-weight-bold" }

import { computed, nextTick } from "vue"
import useRouteParams from '@/composables/useRouteParams'
import { usePartCollectionsData } from "@/composables/collections/usePartCollectionsData"
import useDetailPage from "../details/useDetailPage"
import useI18n from "@/locales/useI18n"
import { usePartCollectionSearch } from '@/composables/collections/usePartCollectionSearch'
import { useBreakpoints } from '@/helpers/responsiveBreakpoints'


export default /*#__PURE__*/_defineComponent({
  __name: 'PartCollectionButtons',
  setup(__props) {

const { id } = useRouteParams()
const { collections, selectCollection } = usePartCollectionsData(
  id.value,
  (part: any) => part
)
const { content, showPartCollections } = useDetailPage()
const { t } = useI18n()
const {
  clearSearch: clearPartCollectionSearch,
  isSearchMode
} = usePartCollectionSearch(
  id.value,
  () => {}
)
const { width } = useBreakpoints()

const isMobile = computed(() => {
  return width.value <= 768
})
const topCollections = computed(() => {
  if (isMobile.value) return collections.value.slice(0, 3)
  return collections.value.slice(0, 6)
})
const totalCollections = computed(() => {
  return content.value?.partCollectionsCount ?? 0
})
const showFooter = computed(() => {
  if (totalCollections.value === 0) return false
  return topCollections.value.length !== totalCollections.value
})
const footerMessage = computed(() => {
  return t("mOfNShown", { 
    m: topCollections.value.length, 
    n: totalCollections.value 
  })
})

const navigateToPartCollections = () => {
  document.getElementById("PartCollections")?.scrollIntoView()
}
const handleCollectionSelection = (collectionId: number) => {
  selectCollection(collectionId)
  if (isSearchMode.value) clearPartCollectionSearch()
  nextTick(() => navigateToPartCollections())
}

return (_ctx: any,_cache: any) => {
  return (_unref(showPartCollections))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("article", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topCollections.value, (collection) => {
            return (_openBlock(), _createElementBlock("button", {
              class: "button is-primary",
              onClick: _withModifiers(($event: any) => (handleCollectionSelection(collection.id)), ["stop"])
            }, [
              _createElementVNode("span", null, _toDisplayString(collection.name), 1)
            ], 8, _hoisted_3))
          }), 256))
        ]),
        (showFooter.value)
          ? (_openBlock(), _createElementBlock("article", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(footerMessage.value), 1),
              _createElementVNode("p", {
                class: "has-text-link has-text-weight-bold",
                onClick: navigateToPartCollections
              }, _toDisplayString(_ctx.$t('goToPartCollections', { partCollections: _ctx.$tc('partCollection', 2) })), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})